import './Checkbox.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import addQueryString, { removeQueryString } from './index';
import { useLocation, useHistory } from 'react-router-dom';
import { qsToObject } from '../../utils/querystring';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
var Checkbox = function Checkbox(_ref) {
  var fields = _ref.fields,
    setFilter = _ref.setFilter,
    clearAlllFilters = _ref.clearAlllFilters,
    facetsName = _ref.facetsName,
    analytics = _ref.analytics,
    getFilterValue = _ref.getFilterValue,
    _ref$columnsClass = _ref.columnsClass,
    columnsClass = _ref$columnsClass === void 0 ? 'col-md-4' : _ref$columnsClass,
    _ref$withMapModalView = _ref.withMapModalView,
    withMapModalView = _ref$withMapModalView === void 0 ? false : _ref$withMapModalView;
  var location = useLocation();
  var queryParams = qsToObject(location.search);
  var label = get(fields, 'title.jss.value');
  var filterName = get(fields, 'name');
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var history = useHistory();
  var checkboxes = /*#__PURE__*/React.createRef();
  var selectedQuery = queryParams.free;
  if (selectedQuery === 'true') {
    selectedQuery = true;
  } else {
    selectedQuery = false;
  }
  React.useEffect(function () {
    if (clearAlllFilters) {
      checkboxes.current.checked = false;
      removeQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  }, [clearAlllFilters]);
  var changeCheckbox = function changeCheckbox(checked) {
    tealiumClickFunc(tealiumMergeClickData(analytics.filterAnalytics, analytics.params), "".concat(filterName, " : ").concat(checked ? 'Select' : 'Deselect'));
    setFilter();
    if (checked) {
      addQueryString(facetsName, "true", history);
      getFilterValue && getFilterValue(fields.name, facetsName, 'true');
    } else {
      checkboxes.current.checked = false;
      removeQueryString(facetsName, history);
      getFilterValue && getFilterValue(fields.name, facetsName, null);
    }
  };
  React.useEffect(function () {
    return function () {
      if (!withMapModalView) {
        removeQueryString(facetsName, history);
      }
    };
  }, []);
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    columnsClass: columnsClass
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field checkbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "switch__field"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-small switch__text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "switch"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(withMapModalView ? 'switch-2-map-view' : 'switch-2'),
    title: label,
    "aria-label": label
  }, /*#__PURE__*/React.createElement("input", {
    defaultChecked: selectedQuery,
    checked: selectedQuery,
    className: "fp__checkbox",
    type: "checkbox",
    value: "true",
    onChange: function onChange(e) {
      changeCheckbox(e.target.checked);
    },
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13) {
        e.preventDefault();
        changeCheckbox(!e.target.checked);
        e.target.checked = !e.target.checked;
      }
    },
    ref: checkboxes,
    id: "".concat(withMapModalView ? 'switch-2-map-view' : 'switch-2'),
    title: label,
    "aria-label": label
  }), /*#__PURE__*/React.createElement("div", {
    className: "switch__shape"
  }))))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl,
    columnsClass = _ref2.columnsClass;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(columnsClass)
  }, children);
};
export default Checkbox;
var commonStyles = "c1cs2m1e";
var ltrStyles = "lcpt46g";
var rtlStyles = "r1fd5qq6";